import { render, staticRenderFns } from "./professions.vue?vue&type=template&id=5a9175d5&scoped=true"
import script from "./professions.vue?vue&type=script&lang=js"
export * from "./professions.vue?vue&type=script&lang=js"
import style0 from "./professions.vue?vue&type=style&index=0&id=5a9175d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9175d5",
  null
  
)

export default component.exports